import React from "react";

interface SparklingGradientStarProps {
    gradient?: boolean;
}

export function SparklingGradientStar({
    gradient = true,
    ...props
}: Omit<React.ComponentPropsWithoutRef<"svg">, "viewBox" | "xmlns"> &
    SparklingGradientStarProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="8"
            {...props}
            viewBox="0 0 8 8"
            fill="none"
        >
            <path
                d="M7.5322 4.25859L6.03835 5.00475C5.58912 5.22782 5.22758 5.59244 5.00297 6.04013L4.25681 7.53244C4.15066 7.74475 3.84604 7.74475 3.73989 7.53244L2.99373 6.04013C2.77066 5.59244 2.40604 5.22936 1.95835 5.00475L0.46758 4.25859C0.255273 4.15244 0.255273 3.84782 0.46758 3.74167L1.96143 2.99552C2.41066 2.77244 2.7722 2.40782 2.99681 1.96013L3.74143 0.467825C3.84758 0.255517 4.1522 0.255517 4.25835 0.467825L5.0045 1.96013C5.22758 2.40782 5.5922 2.7709 6.03989 2.99552L7.53373 3.74167C7.74604 3.84782 7.74604 4.15244 7.53373 4.25859H7.5322Z"
                fill={
                    gradient
                        ? "url(#paint0_linear_24129_21338)"
                        : "currentColor"
                }
            />
            <defs>
                <linearGradient
                    id="paint0_linear_24129_21338"
                    x1="0.527385"
                    y1="0.600483"
                    x2="8.14721"
                    y2="7.24892"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export function SparklingGradientMultiStar() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M20.0443 5.7943L19.8721 5.87206L19.7943 6.0443L19.0061 7.79049C19.0059 7.79079 19.0058 7.79107 19.0057 7.79133C19.0055 7.79155 19.0054 7.79176 19.0053 7.79196C19.0042 7.79224 19.0024 7.79252 19 7.79252C18.9977 7.79252 18.9959 7.79224 18.9947 7.79196C18.9947 7.79182 18.9946 7.79166 18.9945 7.79151C18.9944 7.7912 18.9942 7.79086 18.994 7.79049L18.2062 6.03527L18.1286 5.86231L17.9558 5.7843L16.2087 4.99562C16.2083 4.99542 16.2079 4.99522 16.2075 4.99505C16.2075 4.99504 16.2075 4.99503 16.2075 4.99502C16.2075 4.99501 16.2075 4.995 16.2075 4.99499C16.2078 4.99485 16.2081 4.99469 16.2085 4.99453L17.9648 4.20617L18.1378 4.12854L18.2158 3.95574L19.004 2.20955C19.0042 2.20923 19.0043 2.20893 19.0044 2.20865C19.0046 2.20824 19.0048 2.20786 19.005 2.20752C19.005 2.20752 19.005 2.20752 19.005 2.20752C19.005 2.20752 19.0051 2.20752 19.0051 2.20752C19.0052 2.2078 19.0054 2.20811 19.0055 2.20845C19.0057 2.20879 19.0059 2.20915 19.0061 2.20955L19.7939 3.96477L19.8715 4.13773L20.0443 4.21574L21.7905 5.004C21.7908 5.00414 21.7911 5.00428 21.7914 5.00441C21.7918 5.00462 21.7922 5.00481 21.7925 5.00499C21.7925 5.005 21.7925 5.00501 21.7925 5.00502C21.7925 5.00503 21.7925 5.00503 21.7925 5.00504C21.7922 5.00522 21.7918 5.00542 21.7914 5.00563C21.7911 5.00576 21.7908 5.0059 21.7905 5.00604L20.0443 5.7943ZM11.0448 9.70682L11.1224 9.87765L11.2932 9.95525L14.7932 11.5453L14.7953 11.5462C15.1757 11.7169 15.1887 12.2712 14.7917 12.4555C14.7913 12.4557 14.7909 12.4559 14.7905 12.456L11.2932 14.0448L11.1224 14.1224L11.0448 14.2932L9.45481 17.7932L9.45386 17.7953C9.28317 18.1757 8.72886 18.1887 8.54454 17.7916C8.54437 17.7912 8.54419 17.7909 8.54402 17.7905L6.95527 14.2932L6.87766 14.1224L6.70684 14.0448L3.20684 12.4548L3.20474 12.4538C2.82435 12.2832 2.81139 11.7289 3.20839 11.5445C3.20878 11.5444 3.20917 11.5442 3.20957 11.544L6.70684 9.95525L6.87766 9.87765L6.95527 9.70682L8.54527 6.20682L8.54527 6.20683L8.54622 6.20472C8.71954 5.81845 9.28054 5.81845 9.45386 6.20472L9.45385 6.20472L9.45481 6.20682L11.0448 9.70682ZM17.9558 18.2057L18.128 18.128L18.2058 17.9557L18.994 16.2095C18.9942 16.2092 18.9943 16.209 18.9944 16.2087C18.9945 16.2085 18.9946 16.2083 18.9947 16.2081C18.9959 16.2078 18.9977 16.2075 19 16.2075C19.0024 16.2075 19.0042 16.2078 19.0053 16.2081C19.0054 16.2082 19.0055 16.2084 19.0056 16.2085C19.0057 16.2088 19.0059 16.2092 19.0061 16.2095L19.7939 17.9648L19.8715 18.1377L20.0443 18.2157L21.7905 19.004C21.7908 19.0041 21.7911 19.0043 21.7914 19.0044C21.7918 19.0046 21.7922 19.0048 21.7925 19.005C21.7925 19.005 21.7925 19.005 21.7925 19.005C21.7925 19.005 21.7925 19.005 21.7925 19.005C21.7923 19.0052 21.7919 19.0054 21.7916 19.0055C21.7913 19.0057 21.7909 19.0059 21.7905 19.006L20.0353 19.7939L19.8623 19.8715L19.7843 20.0443L18.9961 21.7905C18.9959 21.7908 18.9958 21.7911 18.9956 21.7914C18.9954 21.7918 18.9952 21.7922 18.9951 21.7925C18.9951 21.7925 18.995 21.7925 18.995 21.7925C18.995 21.7925 18.995 21.7925 18.995 21.7925C18.9949 21.7922 18.9947 21.7919 18.9945 21.7916C18.9944 21.7913 18.9942 21.7909 18.994 21.7905L18.2062 20.0353L18.1286 19.8623L17.9558 19.7843L16.2096 18.996C16.2092 18.9959 16.2089 18.9957 16.2087 18.9956C16.2082 18.9954 16.2079 18.9952 16.2075 18.995C16.2075 18.995 16.2075 18.995 16.2075 18.995C16.2075 18.995 16.2075 18.995 16.2075 18.995C16.2079 18.9948 16.2083 18.9946 16.2087 18.9944C16.2089 18.9943 16.2092 18.9941 16.2096 18.994L17.9558 18.2057Z"
                fill="url(#paint0_linear_21425_51819)"
                stroke="url(#paint1_linear_21425_51819)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_21425_51819"
                    x1="3.00463"
                    y1="2.52134"
                    x2="24.1358"
                    y2="20.3213"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_21425_51819"
                    x1="3.00463"
                    y1="2.52134"
                    x2="24.1358"
                    y2="20.3213"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#32D1B7" />
                    <stop offset="0.695" stopColor="#349BC7" />
                    <stop offset="1.0001" stopColor="#3664D6" />
                </linearGradient>
            </defs>
        </svg>
    );
}
